import React, { useEffect, useState } from 'react'

const ProofLoader: React.FC = () => {
  const [dots, setDots] = useState('')

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => {
        if (prev.length >= 3) return ''
        return prev + '.'
      })
    }, 500)

    return () => clearInterval(interval)
  }, [])

  return (
    <div className="flex flex-col items-center justify-center py-8">
      <div className="w-16 h-16 border-4 border-gray-200 dark:border-gray-700 border-t-text-primary dark:border-t-text-primary-dark rounded-full animate-spin mb-4"></div>
      <div className="text-xl font-medium text-text-primary dark:text-text-primary-dark">Generating proof{dots}</div>
    </div>
  )
}

export default ProofLoader
